export default __webpack_public_path__ + "static/media/banner-image-1.8c4c9012.jpg";